
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {sancionStore} from "@/store/sancionStore";
import {http} from "@/config/HttpClient";
import {DateTime} from "luxon";
import {MaterialService} from "@/services/MaterialService";
import {Alert} from "@/addons/Alert";
import InputUnsignedDecimal from "../../components/InputUnsignedDecimal.vue";
import InputUppercaseRequired from "../../components/InputUppercaseRequired.vue";
import InputUppercase from "../../components/InputUppercase.vue";
import {materialStore} from "@/store/materialStore";
import {IngresoService} from "@/services/IngresoService";
import {ingresoStore} from "@/store/ingresoStore";
import * as stream from "stream";
import {UserAuth} from "@/models/UserAuth";

@Component({
  name: "ingresoEdit",
  computed: {
    UserAuth() {
      return UserAuth
    }
  },
  components: {InputUnsignedDecimal, InputUppercaseRequired, InputUppercase},
})
export default class extends Vue {
  sancion = {
    codigo: '',
    meses_plazo: 1,

  }
  @Prop() ingresoEdit!: any
  @Prop() isNew!: boolean
  private iniciado = 'Iniciado'
  private materialStore = materialStore();
  private sancionStore = sancionStore();
  private ingresoStore = ingresoStore();
  private materialService = MaterialService.getInstance();
  private ingresolService = IngresoService.getInstance();
  private fecha = DateTime.now().toFormat("yyyy-MM-dd");
  private headers = [
    {text: "Fecha", value: "fecha"},
    {text: "Acción", value: "accion"},
    {text: "Usuario", value: "user.email"}
  ];

  //search = null;
  validBuscar = false;
  valid = false;
  txtBuscar = '';
  cantidad= 1;
  cantidad_entregada= 1;
  precio_unitario= 1;
  historialVisible = false;

  isEdit = false;
  txtNroTramite = '';
  isLoading = false;
  swEditar = true;
  txtSearch = "";

  get nuevoIngreso(): any[] {
    return this.ingresoStore.ingreso;
  }

  ingreso = {
    id: this.$route.params.ingresoEdit.id,
    numero: this.$route.params.ingresoEdit.numero,
    numero_pedido: this.$route.params.ingresoEdit.numero_pedido,
    tipo: '',
    tipo_id: this.$route.params.ingresoEdit.tipo_id,
    fecha_ingreso: this.$route.params.ingresoEdit.fecha_ingreso,
    empresa_proveedora: this.$route.params.ingresoEdit.empresa_proveedora,
    responsable_material_funcionario_id: this.$route.params.ingresoEdit.responsable_material_funcionario_id,
    es_ingresado: this.$route.params.ingresoEdit.es_ingresado,
    orden_compra: this.$route.params.ingresoEdit.orden_compra,
    fecha_orden_compra: this.$route.params.ingresoEdit.fecha_orden_compra,
    factura: this.$route.params.ingresoEdit.factura,
    nit: this.$route.params.ingresoEdit.nit,
    fecha_factura: this.$route.params.ingresoEdit.fecha_factura,
    solicitud: this.$route.params.ingresoEdit.solicitud,
    url: this.$route.params.ingresoEdit.url,
    verificado_kardex: this.$route.params.ingresoEdit.verificado_kardex,
    empresa_proveedora_id: this.$route.params.ingresoEdit.empresa_proveedora_id
  };
  clientes = [];
  materiales = [];
  cliente_seleccionado = null;
  private cuenta = null;

  //private sancion = [];

  //private sancion = null;

  $refs!: {
    form: HTMLFormElement,
    txtCuenta: HTMLInputElement,
    montoRec: HTMLInputElement,
  };

  mounted(){
    this.getFuncionarioResponsable();
    this.getTipo();
    this.getEmpresaProveedora();
    this.showMaterial();
    this.getHistoriaL();
  }

  get historiales(): any[] {
    return this.ingresoStore.historial;
  }

  get ingresoMaterial(): any[] {
    return this.ingresoStore.ingresoMaterial;
  }

  get loading(): boolean {
    return this.materialStore.loading;
  }

  get esEdiatr(): boolean {
    return this.ingresoStore.esEditar;
  }

  get nuevoCodigo(): string {
    return this.ingresoStore.nuevoCodigo;
  }

  getNuevoCodigo(){
    this.ingresolService.getNuevoCodigo()
  }

  get sancionNueva(): any[] {
    return this.sancionStore.sancionNueva;
  }
  get cliente(): any[] {
    return this.sancionStore.cliente;
  }
  get funcionarioResponsable(): any {
    return this.ingresoStore.funcionario_responsable;
  }

  get tipo(): any {
    return this.ingresoStore.tipo;
  }

  get empresaProveedora(): any {
    return this.ingresoStore.empresa;
  }

  getEmpresaProveedora() {
    this.ingresolService.getEmpresaPorveedora();
  }

  getFuncionarioResponsable(){
    this.ingresolService.getFuncionarioResponsable();
  }
  getTipo(){
    this.ingresolService.getTipo();
  }

  round(value: number) {
    return Math.round(value * 100) / 100;
  }

  getMateriales(value:string) {
    this.loading;
    this.materialService.getMateriales(value);
  }

  @Watch('txtSearch')
  search(value: string) {
    if (value != null && value.length > 2) {
      this.$nextTick().then(() => {
        this.getMateriales(value);
      })
    }
  }
  guardar(){
    if (!this.$refs.form.validate()) {
      return;
    }
    Alert.confirm(`Actualizar el Ingreso del Proveedor: <br>
                    ${this.ingreso.empresa_proveedora}`
    ).then(res => {
      const data = {ingresoId:this.ingreso.id, ingreso:this.ingreso}
      if (res.isConfirmed) {
        this.ingresolService.updateIngreso(data);
        this.$emit('listar')
        this.getHistoriaL()
      }
    })
  }

  addMaterialIngreso(codigo: string) {
    if (this.cantidad > 0 && this.cantidad_entregada > 0 && this.precio_unitario > 0 && (this.cantidad >= this.cantidad_entregada)) {
      const data = {
        codigo: codigo,
        cantidad: this.cantidad,
        cantidad_entregada: this.cantidad_entregada,
        precio_unitario: this.precio_unitario,
        ingreso: this.ingreso.numero
      }
      this.ingresolService.addMaterialIngreso(data);
      this.cantidad = 1;
      this.cantidad_entregada = 1;
      this.precio_unitario = 1;
      this.materialStore.materiales = [];
      this.getHistoriaL()
    } else {
      Alert.error('La cantidad debe ser mayor a 0, la cantidad debe ser mayor o igual a la cantidad entregada')
      return false
    }
  }
  deleteMaterial(id:number){
    const data = {
      id: id,
      ingreso: this.ingreso.numero
    }
    this.ingresolService.deleteMaterialIngreso(data);
    this.getHistoriaL()
  }

  getHistoriaL(){
    const data = {
      ingreso: this.ingreso,
      modelo: 'ingreso',
    };
    this.ingresolService.historial(data);
  }

  updateQuantity(material:object, cantidad_entregada:number){
    const data = {
      material: material,
      ingreso: this.ingreso.numero,
      cantidad_entregada: cantidad_entregada
    }
    this.ingresolService.updateQuantity(data);
  }

  showMaterial(){
    const data = {
      ingresoId: this.ingreso.id,
    }
    this.ingresolService.showMaterial(data);
  }

  deleteMaterialesIngreso(){
    const data = {
      ingreso: this.nuevoCodigo
    }
    this.ingresolService.deleteMaterialesIngreso(data);
    this.getHistoriaL()
  }

  finalizarIngreso(){
    if (!this.$refs.form.validate()) {
      return;
    }
    Alert.confirm(`Esta seguro de finalizar el ingreso? <br>
                    Una vez aceptado se procedera a afectar las cantidades de los materiales ingresados <br>
                    Revise bien por favor`
    ).then(res => {
      const data = {ingreso:this.ingreso, numero:this.ingreso.numero}
      if (res.isConfirmed) {
          this.ingresolService.finalizarIngreso(data);
          //this.ingreso = this.ingresoStore.ingreso;
        //this.$emit('listar')
      }
    })
    this.getHistoriaL()
  }

  confirmarKardex(){
    Alert.confirm(`Confirmar Ingreso? <br>`
    ).then(res => {
      const data = {ingreso:this.ingreso, numero:this.ingreso.numero}
      if (res.isConfirmed) {
        this.ingresolService.confirmarIngreso(data);
        //this.ingreso = this.ingresoStore.ingreso;
        //this.$emit('listar')
      }
    })
    this.getHistoriaL()
  }

  escogerDocumento(event: any) {
    this.files = event.target.files;
  }

  async save() {
    //let url = "cargarDocumento/" + this.nuevoCodigo;
    let formData = new FormData();

    //cargando varios archivos para enviarlo al servidor
    for (let i = 0; i < this.files.length; i++) {
      let file = this.files[i];
      formData.append("url[" + i + "]", file);
    }

    let headers = {'Content-Type': 'multipart/form-data'};

    //const data = {url,formData,config}
    this.ingresolService.adjuntarDocumento(this.ingreso.id,formData, headers);


  }

  verDocumento() {
    this.ingresolService.imprimirFactura(this.ingreso.id);
  }

  imprimir(id:number){
    if (id === undefined){
      Alert.error('Primero guarde el Ingreso')
      return false
    }
    this.ingresolService.imprimirIngreso(id);

  }

}
